import { observer } from "mobx-react";
import { TicketDto } from "../../api-client";
import { Tabs } from "@mui/material";
import UpdateTicketForm from "./TicketEditCreate/updateTicketForm";

const TicketDialog: React.FC<{
  open: boolean;
  handleClose: () => void;
  ticketId?: number;
  refresh?: boolean;
  setRefresh?: (value: boolean) => void;
  onTicketUpdate?: (ticket: TicketDto) => void;
}> = observer(
  ({ open, handleClose, ticketId, refresh, setRefresh, onTicketUpdate }) => {
    return (
      <>
        <UpdateTicketForm
          key={ticketId ?? 'no-ticket'}
          ticketId={ticketId}
          openTicket={open}
          onCloseTicketForm={handleClose}
        />
        <Tabs
          value="All"
          indicatorColor="primary"
          textColor="primary"
          centered
        />
      </>
    );
  }
);

export default TicketDialog;
